import requests from './requests';
import createWindow from './type-selection-window';
import computerRequest from "./computer-request/computer-request";
import vehicleRequest from "./vehicle-request/vehicle-request";
import generalRequest from "./general-request/general-request";

export default function (nameAction, namePage) {
    if (nameAction === 'requests') {
        requests(namePage);
        createWindow();
    }
    if (nameAction === 'technologyrequest') computerRequest(namePage);
    if (nameAction === 'vehiclerequest') vehicleRequest(namePage);
    if (nameAction === 'generalrequest') generalRequest(namePage);

    ////////////////////////////////////////////////////////////////////
    populateCompanyAddress();
}

const populateCompanyAddress = () => {
    const $company = $('[name=Company]');
    const k_company = $company.data('kendoDropDownList');

    if (k_company) {
        k_company.bind('change', function () {
            $.post('/Finance/CapitalExpenditures/GetCompanyAddress', {company: k_company.value()}, function (response) {
                $('[name="RequesterContact.MailingAddress"]').val(response.MailingAddress);
                $('[name="RequesterContact.MailingCity"]').val(response.MailingCity);
                let k_requesterState = $('[name="RequesterContact.MailingState"]').data('kendoDropDownList');
                if (k_requesterState) k_requesterState.value(response.MailingState);
                $('[name="RequesterContact.MailingZip"]').val(response.MailingZip);
                $('[name="RequesterContact.Phone"]').val(response.Phone);
            })
        })
    }
}
